import React from "react";
import ScheduleIcon from '@material-ui/icons/Schedule';
import BlockIcon from '@material-ui/icons/Block';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

//0 Черновик
//1 Запущена (Стартована)
//2 Остановлено обучение

export const StateName = (stateid) => {
  switch(stateid) {
    case 0:
      return "ИДЕТ НАБОР";
    case 1:
      return "ИДЕТ ОБУЧЕНИЕ";
    case 2:
      return "ЗАВЕРШЕНО";
    default:
      return "БЕЗ СТАТУСА";
  }
}

export const SmallStateIcon = (stateid) => {
  switch(stateid) {
    case 0:
      return <ScheduleIcon/>;
    case 1:
      return <PlayCircleOutlineIcon/>;
    case 2:
      return <BlockIcon/>;
    default:
      return <HelpOutlineIcon/>;
  }
};

export const getStateTextColor = (stateid) => {
  switch(stateid) {
    case 0:
      return "#304967";
    case 1:
      return "#85C446";
    case 2:
      return "#CACCD1";
    default:
      return "#000000";
  }
};

export default {
  getStateTextColor
}
